import { Classificazione } from './classificazione';
import { Controparte } from './controparte';
import { TipoGenericoRimovibile } from './tipologiche/tipo-generico-rimovibile';

export class DettaglioEsito {
    id: string;
    classificazione: Classificazione;
    controparte: Controparte;
    tipoDettaglio: TipoGenericoRimovibile;
    //controparti: Controparte[];
    //classificazioni: Classificazione[];
    note: string;
}
